var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VueMarkdown',{attrs:{"source":_vm.fieldDescription,"plugins":_vm.plugins}})
}
var staticRenderFns = []

export { render, staticRenderFns }